import React from 'react';
import PropTypes from 'prop-types';

import Button from 'rebook/apps/base/components/Button';


const getButtonUrl = ({
  book,
  isReaderUnavailable,
  isRented,
  isAvalibleForRent,
  isAvailableForReadingInRent,
  isUserHasNeededSubscription,
  unknownUser,
  isAvailableForRentForAnonymousUser,
}) => {
  const author = book.authors && book.authors[0].absolute_url;
  const slug = book.slug;

  if (isAvailableForRentForAnonymousUser && unknownUser) {
    return `${author}${slug}/payments/`;
  }

  if (isUserHasNeededSubscription || isAvailableForReadingInRent || book.subscription_id === null) {
    return book.getReaderUrl();
  }

  if (isRented || isAvalibleForRent) {
    return `${author}${slug}/payments/`;
  }

  if (isReaderUnavailable) {
    return '/payments/';
  }

  return book.getReaderUrl();
};


const BookReadButton = ({
  book,
  children,
  isReaderUnavailable,
  extraClassName,
  GACategory,
  isRented,
  isAvalibleForRent,
  isAvailableForReadingInRent,
  isUserHasNeededSubscription,
  isAvailableForRentForAnonymousUser,
  unknownUser,
}) => {
  const sendGA = () => {
    if (isAvailableForRentForAnonymousUser && unknownUser) {
      return ga('send', 'event', GACategory, 'PushButton', 'Paywall');
    }
    else if (isRented) {
      return ga('send', 'event', GACategory, 'PushButton', 'GoToPaywallAgain');
    }
    else if (isAvalibleForRent) {
      return ga('send', 'event', GACategory, 'PushButton', 'GoToPaywall');
    }
    return ga('send', 'event', GACategory, 'PushButton', 'Read');
  };
  return (
    <Button
      url={
        getButtonUrl({
          book,
          isReaderUnavailable,
          isRented,
          isAvalibleForRent,
          isAvailableForReadingInRent,
          isUserHasNeededSubscription,
          isAvailableForRentForAnonymousUser,
          unknownUser,
        })
      }
      extraClassName={extraClassName}
      handleClick={() => {
        sendGA();
        yaMetrikaReachGoal('BookOpen');
      }}>
      {children}
    </Button>
  );
};

BookReadButton.propTypes = {
  book: PropTypes.object.isRequired,
  extraClassName: PropTypes.string,
  GACategory: PropTypes.string,
};

export default BookReadButton;
